module.exports = __webpack_public_path__ + "img/boat2.ab0e2829.png";